<script>
  import schemaData from "../../Stores/wpn2SchemaStore.js";

  export let item;
  export let showTitle = false;
  let status = item.status ?? "Unknown";
</script>

<div id="status-col">
    {showTitle
      ? $schemaData["keysList"].find((x) => x.key === "status").title +
        ": " +
        status
      : status}
</div>

<style>
  #status-col {
    text-align: left;
  }
</style>
